import React from 'react'
import _ from 'lodash'
import PercentCompleteFormatter from './PercentCompleteFormatter'
import MaterialEditor from './MaterialEditor'
import { getUserPermissions } from '../../../utils/userPermissions'
import { API_BASE_URL } from '../../../utils/apiConfig'
import WELD_COLUMN_DEFINITIONS from './weldColumnDefinitions'
import WpsViewModal from './wps/WpsViewModal'

import { Editors, Filters } from 'react-data-grid-addons'
import WeldTypeMultiSelectEditor from './WeldTypeMultiSelectEditor'
import DateRangeFilter from './DateRangeFilter'
import { UncontrolledTooltip } from 'reactstrap'
const { NumericFilter, MultiSelectFilter } = Filters
const { DropDownEditor } = Editors

class NumericFloatFilter extends NumericFilter {
  handleKeyPress(e) { // Validate the input
    let regex = '>|<|-|,|.|([0-9])'
    let result = RegExp(regex).test(e.key)
    if (result === false) {
      e.preventDefault()
    }
  }
}

/* eslint-disable react/display-name, react/prop-types */
export default function getGridColumns() {
  let permitedColumns = getUserPermissions('wl_welds.welds.grid_columns') || []
  let userConfig = this.props.userColumnConfig
  let disabledColumns = { basics: [], inspections: [] }

  if (userConfig && userConfig.hidden_columns) {
    userConfig.hidden_columns.forEach(colId => {
      if (colId.startsWith('$inspections_')) {
        const inspNum = Number(colId.replace('$inspections_', '').replace('_date', ''))
        if (!isNaN(inspNum)) disabledColumns.inspections.push(inspNum)
      } else {
        disabledColumns.basics.push(colId)
      }
    })
  } else {
    disabledColumns = JSON.parse(localStorage.getItem('weldsGridDisabledColumns')) || { basics: [], inspections: [] }
  }

  let gridColumns = _.difference(permitedColumns, disabledColumns.basics)

  let allColumns = [
    this.state.include_project_descendants_welds && !disabledColumns.basics.includes('element') &&
    {
      key: 'element',
      name: 'Element',
      width: 80,
      editable: false,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('no') &&
    {
      key: 'no',
      name: 'Weld No',
      width: 80,
      editable: true,
      filterable: true,
      frozen: true,
      sortable: true,
      cellClass: 'weld-no-column',
      filterRenderer: ExtraDataFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('weld_type') &&
    {
      key: 'weld_type',
      name: 'Weld Type',
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        const content = genrateWeldJointTypeFormater(this.props.weldTypeDict)({ value })
        return <div className={className}>{content}</div>
      },
      editable: false,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      events: {
        onDoubleClick: (ev, args) => {
          this.setState({ weldTypeModal: true, LogModalWeldIdx: [args.rowIdx] })
        }
      }
    },
    gridColumns.includes('length') &&
    {
      key: 'length',
      name: <div>Length<br />[mm]</div>,
      editable: true,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('diameter_1') &&
    {
      key: 'diameter_1',
      name: <div>Diameter 1<br />[mm]</div>,
      editable: true,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('thickness_1') &&
    {
      key: 'thickness_1',
      name: <div>Thickness 1<br />[mm]</div>,
      width: 85,
      editable: true,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('diameter_2') &&
    {
      key: 'diameter_2',
      name: <div>Diameter 2<br />[mm]</div>,
      editable: true,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('thickness_2') &&
    {
      key: 'thickness_2',
      name: <div>Thickness 2<br />[mm]</div>,
      width: 86,
      editable: true,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      }
    },
    gridColumns.includes('material_1') &&
    {
      key: 'material_1',
      name: 'Material 1',
      width: 120,
      editor: MaterialEditor,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        const content = genrateMaterialFormater()({ value })
        return <div className={className}>{content}</div>
      }
    },
    gridColumns.includes('material_2') &&
    {
      key: 'material_2',
      name: 'Material 2',
      width: 120,
      editor: MaterialEditor,
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        const content = genrateMaterialFormater()({ value })
        return <div className={className}>{content}</div>
      }
    },
    ...getExtraColumns(this.props.extraColumns),
    gridColumns.includes('inspection_category') &&
    {
      key: 'inspection_category',
      name: <div>Inspection<br />category</div>,
      editor: <DropDownEditor options={
        this.props.inspCatList.map(inspCat => ({
          text: inspCat.name,
          value: inspCat.id,
          id: inspCat.id
        }))}
      />,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        const content = genrateInspectionCategoryFormater(this.props.inspCatList)({ value })
        return <div className={className}>{content}</div>
      },
      filterable: true,
      sortable: true,
      filterRenderer: MultiSelectFilter
    },
    gridColumns.includes('wps') &&
    {
      key: 'wps',
      name: 'WPS',
      width: 120,
      editable: false,
      sortable: true,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        const content = genrateWpsFormater((wpsId) => this.setState({ wpsViewModalId: wpsId }))({ value })
        return <div className={className}>{content}</div>
      },
      filterable: true,
      filterRenderer: MultiSelectFilter,
      getRowMetaData: (row) => row,
      events: {
        onClick: (ev, args) => {
          this.setState({ wpsModal: true, LogModalWeldIdx: [args.rowIdx] })
        }
      }
    },
    gridColumns.includes('welding_progress') &&
    {
      key: 'welding_progress',
      name: <div>Welding<br />[%]</div>,
      editable: false,
      filterable: true,
      filterRenderer: MultiSelectFilter,
      formatter: PercentCompleteFormatter,
      events: {
        onDoubleClick: (ev, args) => {
          if (getUserPermissions('wl_welds.welding_logs.create') && this.state.welds[args.rowIdx].id) {
            this.setState({ weldingModal: true, LogModalWeldIdx: [args.rowIdx] })
          }
        }
      }
    },
    gridColumns.includes('welder') &&
    {
      key: 'welder',
      name: 'Welder',
      editable: false,
      filterable: true,
      width: 100,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}><div style={{ fontSize: '10px' }}>{value && value.person && `${value.person.last_name} ${value.person.uuid}`}</div></div>
      }
    },
    gridColumns.includes('last_welding_date') &&
    {
      key: 'last_welding_date',
      name: <div>Last welding<br />date</div>,
      editable: false,
      filterable: true,
      width: 110,
      filterRenderer: DateRangeFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues, row }) => {
        const r = dependentValues || row
        const className = r && r.status === 'removed' ? 'removed-row' : ''
        return <div className={className}><div style={{ fontSize: '10px' }}>{r && r.welder && r.welder.date}</div></div>
      }
    },
    gridColumns.includes('welding_wps') &&
    {
      key: 'welding_wps',
      name: <div>Welding<br />WPS</div>,
      editable: false,
      filterable: true,
      width: 120,
      filterRenderer: MultiSelectFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues, row }) => {
        const r = dependentValues || row
        const className = r && r.status === 'removed' ? 'removed-row' : ''
        const wpsNo = r && r.welder && r.welder.wps_no
        return (
          <div className={className}>
            {wpsNo && wpsNo.split(', ').map((no, i) => (
              <div key={i} style={{ fontSize: '10px' }}>{no}</div>
            ))}
          </div>
        )
      }
    },
    gridColumns.includes('welding_consumables') &&
    {
      key: 'welding_consumables',
      name: <div>Welding<br />Consumables</div>,
      editable: false,
      filterable: true,
      width: 120,
      filterRenderer: MultiSelectFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        const content = generateWeldingConsumablesFormatter(this.props.weldingConsumables)({ value })
        return <div className={className}>{content}</div>
      }
    },
    ...((gridColumns.includes('inspections') && getInspectionColumns(this, this.props, disabledColumns.inspections)) || []),
    gridColumns.includes('status') &&
    {
      key: 'status',
      name: 'Status',
      editable: false,
      filterable: true,
      filterRenderer: MultiSelectFilter,
    },
    gridColumns.includes('blocked_for_import') &&
    {
      key: 'blocked_for_import',
      name: <div>Blocked<br />for import</div>,
      editable: false,
      filterable: true,
      filterRenderer: MultiSelectFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues, row }) => {
        const r = dependentValues || row
        if (!r) return <div />
        return r.blocked_for_import
          ? <div title="Unblock for import" style={{ cursor: 'pointer', textAlign: 'center' }}><i className="fa fa-lock" style={{ color: '#c0392b' }} /></div>
          : <div title="Block for import" style={{ cursor: 'pointer', textAlign: 'center' }}><i className="fa fa-unlock" style={{ color: '#27ae60' }} /></div>
      },
      events: {
        onClick: (ev, args) => {
          ev.preventDefault()
          if (getUserPermissions('wl_welds.welds.block')) {
            this.onBlockToggleHandler(args.rowIdx)
          }
        }
      }
    },
    ...((!disabledColumns.basics.includes('actions') &&
      [
        (getUserPermissions('wl_welds.welds.update') || getUserPermissions('wl_welds.welds.create')) && {
          key: 'actions',
          width: 30,
          formatter: (props) => <div>{props.value.save && <i className="fa fa-save" />}</div>,
          events: {
            onClick: (ev, args) => {
              ev.preventDefault()
              if (this.state.welds[args.rowIdx].actions.save) {
                this.onUpdateHandler([args.rowIdx])
              }
            },
          }
        },
        (getUserPermissions('wl_welds.inspection_logs.index') || getUserPermissions('wl_welds.welding_logs.index')) && {
          key: 'id',
          width: 30,
          formatter: (props) => <div>{props.value && <i className="fa fa-book" />}</div>,
          events: {
            onClick: (ev, args) => {
              ev.preventDefault()
              if (args.rowId) {
                this.props.history.push(`/projects/welds/logs/${args.rowId}`)
              }
            },
          }
        },
        getUserPermissions('wl_welds.welds.destroy') &&
        {
          key: '$destroy',
          width: 30,
          getRowMetaData: (row) => row,
          formatter: ({ dependentValues }) => {
            return dependentValues && dependentValues.status === 'removed' ?
              <div></div> : <div><i className="fa fa-trash-o" /></div>
          },
          events: {
            onClick: (ev, args) => {
              ev.preventDefault()
              const weld = this.state.welds[args.rowIdx]
              if (weld && weld.status !== 'removed') {
                this.setState({ weldsRowIdxToRemove: [args.rowIdx] })
              }
            },
          }
        },
      ]
    ) || []
    )
  ].filter(Boolean)

  if (userConfig && userConfig.column_order) {
    const hiddenColumns = userConfig.hidden_columns || []
    const orderedColumns = []

    userConfig.column_order.forEach(colId => {
      if (!hiddenColumns.includes(colId)) {
        const col = allColumns.find(c => c && c.key === colId)
        if (col) {
          orderedColumns.push(col)
          // insert the paired _date and _report_no columns right after the inspection column
          const dateCol = allColumns.find(c => c && c.key === `${colId}_date`)
          if (dateCol) orderedColumns.push(dateCol)
          const reportNoCol = allColumns.find(c => c && c.key === `${colId}_report_no`)
          if (reportNoCol) orderedColumns.push(reportNoCol)
        }
      }
    })

    allColumns.forEach(col => {
      if (col && !orderedColumns.find(c => c && c.key === col.key) && !hiddenColumns.includes(col.key)) {
        orderedColumns.push(col)
      }
    })

    return orderedColumns.filter(Boolean)
  }

  return allColumns
}

function getInspectionColumns(self, props, disabledColumns) {
  let inspectionColumns = []
  let projectInspections = getProjectDefinedInspections(props.inspCatList)

  props.inspCatTypesDict.map(inspectionDict => {
    let inspId = projectInspections.includes(Number(inspectionDict.id)) && Number(inspectionDict.id)
    if (!inspId || disabledColumns.includes(inspId)) {
      return null
    }

    const doubleClickEvent = {
      onDoubleClick: (ev, args) => {
        const weld = self.state.welds[args.rowIdx]
        const groupEntry = weld && weld.inspection_groups && Object.values(weld.inspection_groups).find(g => String(g.insp_cat_type_id) === String(inspId))
        if (groupEntry && !groupEntry.representative) return
        if (getUserPermissions('wl_welds.inspection_logs.create') && weld && weld.id &&
          isItWeldDefindedInspection(self.props.inspCatList, weld, inspId)) {
          self.setState({ inspectionModal: true, LogModalWeldIdx: [args.rowIdx], LogModalWeldInspId: inspId })
        }
      }
    }

    // Inspector / result column
    inspectionColumns.push({
      key: `$inspections_${inspId}`,
      name: inspectionDict.name,
      filterable: true,
      width: 95,
      filterRenderer: MultiSelectFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues }) => {
        let weldDefindedInspection = isItWeldDefindedInspection(props.inspCatList, dependentValues, inspId)
        let hasFailed = dependentValues.failed_inspections && dependentValues.failed_inspections[inspId]
        const failedIcon = hasFailed && (() => {
          const fp = dependentValues.failed_inspections[inspId]
          const name = fp.person ? `${fp.person.last_name} ${fp.person.uuid}` : ''
          const tooltipId = `fi-${dependentValues.id}-${inspId}`
          return (
            <span>
              <i id={tooltipId} className="fa fa-exclamation-circle" style={{ color: 'red', fontSize: '16px', cursor: 'pointer' }} />
              <UncontrolledTooltip target={tooltipId} placement='top'>
                <div>{name}</div>
                <div>{fp.date}</div>
              </UncontrolledTooltip>
            </span>
          )
        })()
        if (dependentValues.inspections && dependentValues.inspections[inspId]) {
          let color = dependentValues.inspections[inspId].positive === true ? 'green' : dependentValues.inspections[inspId].skipped === true ? 'orange' : 'red'
          let file_url = dependentValues.inspections[inspId].file_url
          let person = dependentValues.inspections[inspId].person
          let complete = dependentValues.inspections[inspId].complete
          let complete_percent = dependentValues.inspections[inspId].complete_percent
          return (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '3px' }}>
              {failedIcon}
              <div style={{ color: color, fontSize: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  {file_url && <a href={API_BASE_URL + file_url} target='_blank'><i className="fa fa-paperclip" /></a>}
                  {person && <span>{`${person.last_name} ${person.uuid}`}</span>}
                </div>
                {(complete != null || complete_percent != null) && (
                  <div style={{ color: color }}>{complete != null ? `${complete}mm` : ''}{complete != null && complete_percent != null ? ' / ' : ''}{complete_percent != null ? `${complete_percent}%` : ''}</div>
                )}
              </div>
            </div>
          )
        }
        else {
          const groupEntry = dependentValues.inspection_groups && Object.values(dependentValues.inspection_groups).find(g => String(g.insp_cat_type_id) === String(inspId))
          if (groupEntry) {
            if (groupEntry.representative) {
              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                  {failedIcon}
                  <span style={{ fontSize: '10px', color: '#20a8d8' }}>
                    <i className="fa fa-object-group" style={{ marginRight: '3px' }} />
                    {`${dependentValues.length}mm/100%`}
                  </span>
                </div>
              )
            } else {
              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                  <i className="fa fa-lock" style={{ color: '#aaa', fontSize: '13px' }} />
                  <span style={{ fontSize: '10px', color: '#aaa' }}>Grouped</span>
                </div>
              )
            }
          } else if (weldDefindedInspection) {
            const effectiveRange = (dependentValues.has_dimensional_control && inspectionDict.name !== 'RI') ? Math.min(Math.round(dependentValues.dc_weld_failed / dependentValues.length * 100), 100) : weldDefindedInspection.range
            let weldInspTypeComplete = Math.round(dependentValues.length * effectiveRange / 100)
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                {failedIcon}
                <span className='GridPlaceholder'>{`${weldInspTypeComplete}mm/${effectiveRange}%`}</span>
              </div>
            )
          } else {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                {failedIcon}
                <i className="fa fa-ban" />
              </div>
            )
          }
        }
      },
      events: doubleClickEvent
    })

    // Grouping column — skip for RI
    if (inspectionDict.name !== 'RI') inspectionColumns.push({
      key: `$inspections_${inspId}_grouping`,
      name: <div>{inspectionDict.name}<br />Grouping</div>,
      editable: false,
      filterable: true,
      width: 95,
      filterRenderer: MultiSelectFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues }) => {
        const groupEntry = dependentValues.inspection_groups && Object.entries(dependentValues.inspection_groups).find(([, g]) => String(g.insp_cat_type_id) === String(inspId))
        if (groupEntry) {
          return <div style={{ fontSize: '10px', color: '#20a8d8' }}>Group id {groupEntry[0]}</div>
        }
        return <div style={{ fontSize: '10px', color: '#999' }}>single</div>
      }
    })

    // Date column
    inspectionColumns.push({
      key: `$inspections_${inspId}_date`,
      name: <div>{inspectionDict.name}<br />Date</div>,
      editable: false,
      filterable: true,
      width: 95,
      filterRenderer: DateRangeFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues }) => {
        if (dependentValues.inspections && dependentValues.inspections[inspId]) {
          let color = dependentValues.inspections[inspId].positive === true ? 'green' : dependentValues.inspections[inspId].skipped === true ? 'orange' : 'red'
          let date = dependentValues.inspections[inspId].date
          return <div style={{ color: color, fontSize: '10px' }}>{date}</div>
        }
        return <div />
      },
      events: doubleClickEvent
    })

    // Report No column — skip for RI inspection type
    if (inspectionDict.name !== 'RI') inspectionColumns.push({
      key: `$inspections_${inspId}_report_no`,
      name: <div>{inspectionDict.name}<br />Report No</div>,
      editable: false,
      filterable: true,
      width: 110,
      filterRenderer: ExtraDataFilter,
      getRowMetaData: (row) => row,
      formatter: ({ dependentValues }) => {
        if (dependentValues.inspections && dependentValues.inspections[inspId]) {
          let color = dependentValues.inspections[inspId].positive === true ? 'green' : dependentValues.inspections[inspId].skipped === true ? 'orange' : 'red'
          let report_no = dependentValues.inspections[inspId].report_no
          return <div style={{ color: color, fontSize: '10px' }}>{report_no}</div>
        }
        return <div />
      },
      events: doubleClickEvent
    })

    return inspectionColumns
  })
  return inspectionColumns
}

function isItWeldDefindedInspection(inspCatList, weld, inspId) {
  if (weld.inspection_category) {
    let WeldInspCat = inspCatList.find(inspCat => inspCat.id === weld.inspection_category)
    return WeldInspCat ? (_.find(WeldInspCat.inspections, (o) => o.type_id === inspId) || null) : null
  }
}

function getProjectDefinedInspections(inspCatList) {
  let inspectionsArrIds = []
  inspCatList.map(inspCat => inspectionsArrIds.push(...inspCat.inspections.map(o => o.type_id)))
  return _.uniq(inspectionsArrIds)
}

function ExtraDataFilter({ column, onChange }) {
  return (
    <input
      className="form-control input-sm"
      placeholder="exact (or %like%), __ for empty"
      onChange={e => onChange({ filterTerm: e.target.value || null, column, rawValue: e.target.value })}
    />
  )
}

function getExtraColumns(extra_columns) {
  let extraColumns = []
  Object.keys(extra_columns).map(col_key => {
    extraColumns.push({
      key: col_key,
      name: <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{extra_columns[col_key]}</div>,
      width: 160,
      editable: true,
      filterable: true,
      sortable: true,
      filterRenderer: ExtraDataFilter,
      formatter: ({ value, row }) => {
        const className = row && row.status === 'removed' ? 'removed-row' : ''
        return <div className={className}>{value}</div>
      },
    })
    return extraColumns
  })
  return extraColumns
}

function genrateWpsFormater(onOpenWps) {
  return ({ value }) => {
    if (Array.isArray(value) && value.length > 0) {
      return (
        <div>
          {value.map((wpsItem, index) => (
            <div key={wpsItem.id || index} style={{ fontSize: '11px' }}>
              <i
                className="fa fa-paperclip"
                style={{ cursor: 'pointer', marginRight: '4px' }}
                onClick={e => { e.stopPropagation(); onOpenWps && onOpenWps(wpsItem.id) }}
                style={{ color: '#20a8d8', cursor: 'pointer' }}
              />
              {wpsItem.no}
            </div>
          ))}
        </div>
      )
    } else {
      return <div></div>
    }
  }
}

function genrateInspectionCategoryFormater(inspectionCategoryList) {
  return ({ value }) => {
    let inspCat = inspectionCategoryList.find(inspCat => inspCat.id === value)
    if (inspCat) {
      return <div>{inspCat.name}</div>
    } else {
      return <div></div>
    }
  }
}

function genrateWeldTypeFormater(weldTypeDict) {
  return ({ value }) => {
    let weld_type = weldTypeDict.find(weld_type => weld_type.value === value)
    if (weld_type) {
      return <div>{weld_type.text}</div>
    } else {
      return <div></div>
    }
  }
}

function genrateMaterialFormater() {
  return ({ value }) => {
    if (value) {
      return <div>{value.designation_name}</div>
    } else {
      return <div></div>
    }
  }
}

function generateWeldingConsumablesFormatter(consumablesDict) {
  return ({ value }) => {
    if (Array.isArray(value) && value.length > 0) {
      return (
        <div>
          {value.map((item, index) => (
            <div key={item.id || index} style={{ fontSize: '10px' }}>
              {item.name}
            </div>
          ))}
        </div>
      )
    }
    return <div></div>
  }
}

function genrateWeldJointTypeFormater(weldTypeDict) {
  return ({ value }) => {
    if (Array.isArray(value) && value.length > 0) {
      return (
        <div>
          {value.map((wjt, index) => {
            let displayText = ''
            if (wjt.weld_type && wjt.joint_type) {
              // GraphQL format: pełne obiekty
              displayText = `${wjt.weld_type.name}-${wjt.joint_type.name}`
            } else if (wjt.weld_type && !wjt.joint_type) {
              // GraphQL format: tylko weld_type
              displayText = wjt.weld_type.name
            } else if (wjt.weld_type_id) {
              // Local format: tylko ID
              const weldTypeEntry = weldTypeDict.find(w => {
                const [weldId, jointId] = w.value.split('-')
                return weldId == wjt.weld_type_id && (wjt.joint_type_id ? jointId == wjt.joint_type_id : !jointId)
              })
              if (weldTypeEntry) {
                displayText = weldTypeEntry.text
              } else {
                const weldOnly = weldTypeDict.find(w => w.value.split('-')[0] == wjt.weld_type_id)
                displayText = weldOnly ? weldOnly.text.split('-')[0] : `ID:${wjt.weld_type_id}`
              }
            }
            return (
              <div key={index} style={{ fontSize: '11px' }}>
                {displayText}
              </div>
            )
          })}
        </div>
      )
    } else {
      return <div></div>
    }
  }
}
/* eslint-enable react/display-name, react/prop-types */



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/getGridColumns.js